import { Row, RowProps } from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableFooterProperties<T extends object> = RowProps<T> & {
    className?: string
}

export const TableFooter = <T extends object>({
    className,
    ...properties
}: Readonly<TableFooterProperties<T>>): JSX.Element => {
    return (
        <Row
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
